import { useSelector } from 'react-redux'

export default () => {
  const gaFlags = useSelector(state => state.appReducer.appconfig?.app?.gaFlags)
  return gaFlags || {}
}
